import * as React from 'react';

/** The folder rename in progress in a tree, which the tree's host owns. */
export type TreeRename = {
  /** The tree item being renamed; null while nothing is. */
  renamingId: string | null;
  /** Validation or API message for the rename in progress. */
  error?: string | null;
  /** True while the rename request is in flight. */
  isSaving?: boolean;
  /** Called with the new name when the rename is confirmed (Enter / blur). */
  onCommit: (name: string) => void;
  /** Called when the rename is abandoned (Escape). */
  onCancel: () => void;
};

const TreeRenameContext = React.createContext<TreeRename | null>(null);

/**
 * Supplies the rename in progress to every row of a tree, so a row takes no
 * rename props of its own: the one being renamed shows its name as a field.
 */
export const TreeRenameProvider = TreeRenameContext.Provider;

/** The rename in progress on this item; null while it is not being renamed. */
export const useTreeItemRename = (itemId: string): TreeRename | null => {
  const rename = React.useContext(TreeRenameContext);
  return rename?.renamingId === itemId ? rename : null;
};
